import React from 'react';
import clsx from 'clsx';
import {
  columnDescription,
  columnNameLink,
  columnEnabled,
  hasColumn,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import ToggleCell from '@/components/table/ToggleCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import events from '../hooks/events';

const ThemeRow = ({
  category,
  theme,
  className,
  columns = [columnNameLink, columnDescription, columnEnabled],
}) => {
  const show = events.useShowSaveTheme(category, theme);
  const toggleEnabled = events.useUpdateThemeEnabled(category, theme);
  return (
    <NameDescriptionRow
      asHref
      className={clsx('aridhia-theme-row', className)}
      columns={columns}
      description={theme.description}
      entity="theme"
      href={codeUrl(urls.THEMES, theme.code)}
      name={theme.name}
      onClick={show}
      loading={theme.updateStatus === states.PENDING}
    >
      {hasColumn(columns, columnEnabled) && (
        <ToggleCell
          checked={theme.enabled}
          disabled={theme.updateStatus === states.PENDING}
          label={theme.name}
          onClick={() => toggleEnabled(theme)}
        />
      )}
    </NameDescriptionRow>
  );
};

export default ThemeRow;
